import { Geolocation } from '@capacitor/geolocation';
import { CABA, CAPITAL } from '../utils/constants';
import { obtenerProvinciasStorage } from './storageHelper';
import { AsistenciaMedicaActionType } from '../interfaces/global-state/asistencia.medica.action.type.enum';

/**
 * Método que se encarga de revisar si el usuario tiene permisos para retornar su geolocalización
 * @param dispatchAsistenciaMedica 
 */
const checkPermisosGeo = (dispatchAsistenciaMedica) => {
    Geolocation.checkPermissions().then((resp) => {
        const isDenied = resp.coarseLocation === 'denied' || resp.location === 'denied';
        if (isDenied) {
            errorGeolocalizacion(dispatchAsistenciaMedica);
            return;
        }
        inicioLocation(dispatchAsistenciaMedica);
    }).catch((error) => {
        console.error("Ocurrió un problema relacionado con los permisos de geolocalización", 'logsitoerror', {error});
        errorGeolocalizacion(dispatchAsistenciaMedica);
    })
}

/**
 * Método que retorna la geolocalización
 * @param dispatchAsistenciaMedica
 */
const inicioLocation = (dispatchAsistenciaMedica) => {
    let optionsGeoLoc = {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 30000,
    };
    Geolocation.getCurrentPosition(optionsGeoLoc).then((geo) => {
        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
            geolocalizacion: geo
        });
    }).catch((error) => {
        console.error("Ocurrió un problema al recuperar la geolocalización", error);
        //TODO utilizar un useMemo
        // dispatchAsistenciaMedica({
        //     type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
        //     geolocalizacion: null
        // });
    });
};

const inicioLocationWeb = async (dispatchAsistenciaMedica) => {
    try {
        let optionsGeoLoc = {
            enableHighAccuracy: true,
            timeout: 20000,
            maximumAge: 30000,
        };
        const geo = await Geolocation.getCurrentPosition(optionsGeoLoc);

        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
            geolocalizacion: geo
        });

        return geo;
    } catch (error) {
        console.error("Ocurrió un problema al recuperar la geolocalización", error);
        //TODO usar un useMemo
        // dispatchAsistenciaMedica({
        //     type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
        //     geolocalizacion: null
        // });

        throw error;
    }
};

const errorGeolocalizacion = (dispatchAsistenciaMedica) => {
    //TODO usar un useMemo
    // dispatchAsistenciaMedica({
    //     type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
    //     geolocalizacion: null
    // });
}

const validarProvincia = async (apiRequest, storageManager, provincia) => {
    let encuentraProvincia = false;
    await obtenerProvinciasStorage( apiRequest, storageManager ).then( provs => {
        let index = provs.findIndex(prov => prov.nombre.toUpperCase() == CAPITAL);
        provs[index].nombre = CABA;
        let prov = provs.find( prov => prov.nombre === provincia );
        encuentraProvincia = prov ? true : false;
    }).catch( error => {
        console.error("ASIS-MED - Error al inicializar listado de provincias", error);
    });
    return encuentraProvincia;
}

export {checkPermisosGeo, inicioLocation, inicioLocationWeb, validarProvincia}